<template>
  <q-tab :class="tabClass">
    <div class="flex no-wrap items-center">
      <slot name="icon"></slot>
      <span>
        <slot></slot>
      </span>
    </div>
  </q-tab>
</template>

<script setup>
const props = defineProps({
  indicator: {
    type: String,
    default: "line",
  },
  tabClass: {
    type: String,
    default: "chip rounded-borders overflow-hidden",
  },
});

const tabClass = computed(() => {
  return props.indicator === "line" ? "line" : props.tabClass;
});
</script>

<style lang="scss" scoped>
.q-tab {
  min-height: 38px;

  :deep(.q-focus-helper) {
    display: none;
  }

  :deep(.q-tab__content) {
    .q-tab {
      &__label {
        font-size: 12px;
      }
    }
  }

  &.chip:deep(.q-tab__indicator) {
    display: none;
  }

  &:hover {
    color: $primary;
  }
}
</style>
